import { render, staticRenderFns } from "./LvContentTabBar001.vue?vue&type=template&id=372d4ffa"
import script from "./LvContentTabBar001.vue?vue&type=script&lang=js"
export * from "./LvContentTabBar001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports